import script from "./NodeInputSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./NodeInputSummary.vue?vue&type=script&setup=true&lang=ts"

import "./NodeInputSummary.vue?vue&type=style&index=0&id=524dcd45&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524dcd45"]])

export default __exports__